import { useContext, useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'

import {
  IconButton,
  Menu,
  MenuItem,
  useMediaQuery,
  useTheme
} from '@material-ui/core'
import { Replay } from '@material-ui/icons'

import Tooltip from '@material-ui/core/Tooltip'
import {
  Calendar,
  CircleCheck,
  CirclePlus,
  Globe,
  Info,
  Repeat,
  UserPlus,
  UserRoundArrowLeft,
  Users,
  X
} from 'lucide-react'
import { AuthContext } from '../../context/Auth/AuthContext'
import { TicketsContext } from '../../context/Tickets/TicketsContext'
import toastError from '../../errors/toastError'
import useClosingReasonSettings from '../../hooks/useClosingReasonSettings'
import api from '../../services/api'
import { i18n } from '../../translate/i18n'
import ButtonWithSpinner from '../ButtonWithSpinner'
import ClosingReasonModal from '../ClosingReasonModal'
import ConfirmationModal from '../ConfirmationModal'
import ScheduleModal from '../ScheduleModal'
import TaskModal from '../TaskModal'
import TicketAttendantsModal from '../TicketAttendantsModal'
import TicketOptionsMenu from '../TicketOptionsMenu'
import TransferTicketModalCustom from '../TransferTicketModalCustom'
import TransferWhenClosingModal from '../TransferWhenClosingModal'

import NewTicketModalWecloud from '../NewTicketModalWecloud'
import { useStyles } from './style'
import { ButtonPrimary } from '../ButtonPrimary'
import { ButtonAddNew } from '../ButtonAddNew'

const TicketActionButtonsCustom = ({ ticket, showTabGroups, onClick }) => {
  const classes = useStyles()
  const history = useHistory()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  const [anchorEl, setAnchorEl] = useState(null)
  const [loading, setLoading] = useState(false)
  const ticketOptionsMenuOpen = Boolean(anchorEl)
  const [transferTicketModalOpen, setTransferTicketModalOpen] = useState(false)
  const { user } = useContext(AuthContext)
  const isMounted = useRef(true)
  const { setCurrentTicket } = useContext(TicketsContext)

  const [confirmationOpen, setConfirmationOpen] = useState(false)
  const [contactId, setContactId] = useState(null)
  const [scheduleModalOpen, setScheduleModalOpen] = useState(false)
  const [taskModalOpen, setTaskModalOpen] = useState(false)
  const [, setKey] = useState(0)
  const [closingReasonModalOpen, setClosingReasonModalOpen] = useState(false)
  // const [queues, setQueues] = useState([])
  const [selectedQueueForAccept] = useState('')
  const [newTicketModalOpen, setNewTicketModalOpen] = useState(false)
  const [attendantsModalOpen, setAttendantsModalOpen] = useState(false)
  const [transferWhenClosingModalOpen, setTransferWhenClosingModalOpen] =
    useState(false)

  const [linkedAttendants, setLinkedAttendants] = useState([])
  const [mobileAnchorEl, setMobileAnchorEl] = useState(null)
  const mobileMenuOpen = Boolean(mobileAnchorEl)

  const { shouldRequireClosingReason, hasClosingReasonsForTicket } =
    useClosingReasonSettings()
  // const { findAll: findAllQueues } = useQueues()

  // const [infoDrawerOpen, setInfoDrawerOpen] = useState(false)

  const canShowManagementButtons = !showTabGroups || !ticket.isGroup
  const isTicketOpenOrGroup =
    ticket.status === 'open' || (showTabGroups && ticket.isGroup)
  const isNotGroup = !ticket.isGroup

  useEffect(() => {
    isMounted.current = true
    return () => {
      isMounted.current = false
    }
  }, [])

  // useEffect(() => {
  //   const loadQueues = async () => {
  //     try {
  //       const list = await findAllQueues()
  //       if (isMounted.current) {
  //         setQueues(list)
  //       }
  //     } catch (err) {
  //       toastError(err)
  //     }
  //   }
  //   loadQueues()
  // }, [])

  const handleCloseTicket = async (id, closingReasonId = null) => {
    try {
      const updateData = {
        status: 'closed',
        justClose: true,
        userId: user?.id
      }

      if (closingReasonId) {
        updateData.closingReasonId = closingReasonId
      }

      await api.put(`/tickets/${id}`, updateData)
      setKey(prevKey => prevKey + 1)
      history.push('/tickets')
    } catch (err) {
      toastError(err)
    }
  }
  const handleOpenScheduleModal = () => {
    setContactId(ticket.contact.id)
    setScheduleModalOpen(true)
  }
  const handleCloseScheduleModal = () => {
    setScheduleModalOpen(false)
    setContactId(null)
  }

  // const handleOpenTaskModal = () => {
  //   setTaskModalOpen(true)
  // }

  const handleCloseTaskModal = () => {
    setTaskModalOpen(false)
  }

  const handleOpenAttendantsModal = () => {
    setAttendantsModalOpen(true)
  }

  const handleCloseAttendantsModal = () => {
    setAttendantsModalOpen(false)
  }

  // const handleOpenTicketOptionsMenu = e => {
  //   setAnchorEl(e.currentTarget)
  // }

  const handleCloseTicketOptionsMenu = () => {
    setAnchorEl(null)
  }

  const handleOpenTransferModal = e => {
    setTransferTicketModalOpen(true)
  }

  const handleCloseTransferTicketModal = () => {
    if (isMounted.current) {
      setTransferTicketModalOpen(false)
    }
  }

  const handleDeleteTicket = async () => {
    try {
      await api.delete(`/tickets/${ticket.id}`)
    } catch (err) {
      toastError(err)
    }
  }

  // const handleIconButtonClickReload = () => {
  //   setKey(prevKey => prevKey + 1)
  //   history.push('/tickets')
  // }

  const handleIconButtonClick = () => {
    history.push('/tickets')
  }

  const handleInfoClick = event => {
    if (event) {
      event.preventDefault()
      // event.stopPropagation()
    }
    if (onClick) onClick()
  }

  const executeFinalCloseSteps = async (closingReasonId = null) => {
    const hasReasons =
      shouldRequireClosingReason(ticket) &&
      (await hasClosingReasonsForTicket(ticket))

    if (hasReasons && !closingReasonId) {
      setClosingReasonModalOpen(true)
    } else {
      if (ticket.contact.silencioso) {
        handleCloseTicket(ticket.id, closingReasonId)
      } else {
        handleUpdateTicketStatus(null, 'closed', user?.id, closingReasonId)
      }
    }
  }

  const handleOpenClosingReasonModal = async () => {
    // Verificar se o usuário atual é o atendente principal
    const isMainAttendant = ticket.userId === user?.id

    // Se existir atendente principal e o usuário atual NÃO é ele, apenas desvincula
    if (ticket.userId && !isMainAttendant) {
      try {
        setLoading(true)
        await api.delete(`/ticket-attendants/${ticket.id}/${user?.id}`)
        setLoading(false)
        history.push('/tickets')
      } catch (err) {
        setLoading(false)
        toastError(err)
      }
      return
    }

    try {
      setLoading(true)
      const { data } = await api.get(`/ticket-attendants/${ticket.id}`)
      const otherAttendants = Array.isArray(data)
        ? data
          .map(item => item.user)
          .filter(Boolean)
          .filter(attendant => attendant.id !== user?.id)
        : []

      setLoading(false)

      if (otherAttendants.length > 0) {
        setLinkedAttendants(otherAttendants)
        setTransferWhenClosingModalOpen(true)
        return
      }
    } catch (err) {
      setLoading(false)
      toastError(err)
      return
    }

    if (
      shouldRequireClosingReason(ticket) &&
      (await hasClosingReasonsForTicket(ticket))
    ) {
      setClosingReasonModalOpen(true)
    } else {
      if (ticket.contact.silencioso) {
        handleCloseTicket(ticket.id, null)
      } else {
        handleUpdateTicketStatus(null, 'closed', user?.id, null)
      }
    }
  }

  const handleClosingReasonConfirm = closingReasonId => {
    setClosingReasonModalOpen(false)
    if (ticket.contact.silencioso) {
      handleCloseTicket(ticket.id, closingReasonId)
    } else {
      handleUpdateTicketStatus(null, 'closed', user?.id, closingReasonId)
    }
  }

  const handleClosingReasonCancel = () => {
    setClosingReasonModalOpen(false)
  }

  const handleTransferWhenClosingClose = () => {
    setTransferWhenClosingModalOpen(false)
    setLinkedAttendants([])
  }

  const handleConfirmTransferWhenClosing = () => {
    setCurrentTicket({ id: null, code: null })
    history.push('/tickets')
  }

  // const handleConfirmCloseWithoutTransfer = async () => {
  //   setTransferWhenClosingModalOpen(false)

  //   if (
  //     shouldRequireClosingReason(ticket) &&
  //     (await hasClosingReasonsForTicket(ticket))
  //   ) {
  //     setClosingReasonModalOpen(true)
  //     return
  //   }

  //   if (ticket.contact.silencioso) {
  //     handleCloseTicket(ticket.id, null)
  //   } else {
  //     handleUpdateTicketStatus(null, 'closed', user?.id, null)
  //   }
  // }

  const handleUpdateTicketStatus = async (
    e,
    status,
    userId,
    closingReasonId = null
  ) => {
    setLoading(true)
    try {
      const updateData = {
        status: status,
        userId: userId || null
      }

      if (closingReasonId) {
        updateData.closingReasonId = closingReasonId
      }

      // Se o status é 'open' e há uma fila selecionada, atualizar a fila também
      if (status === 'open' && selectedQueueForAccept) {
        updateData.queueId = selectedQueueForAccept
      }

      await api.put(`/tickets/${ticket.id}`, updateData)

      setLoading(false)
      if (status === 'open') {
        setCurrentTicket({ ...ticket, code: '#open' })
        // handleIconButtonClickReload()
        history.push(`/tickets/${ticket.id}`)
      } else {
        setCurrentTicket({ id: null, code: null })
        history.push('/tickets')
      }
    } catch (err) {
      setLoading(false)
      toastError(err)
    }
  }
  const handleNewTicketModalClose = () => {
    setNewTicketModalOpen(false)
  }

  const handleOpenMobileMenu = e => setMobileAnchorEl(e.currentTarget)

  const handleCloseMobileMenu = () => setMobileAnchorEl(null)

  const renderMainActions = () => {
    return (
      <>
        {/* Histórico - Apenas se NÃO for grupo */}
        {isNotGroup && (
          <Tooltip title="Informações de Contato" arrow>
            <IconButton
              className={classes.actionButtonIcons}
              onClick={handleInfoClick}
            >
              <Info />
            </IconButton>
          </Tooltip>
        )}

        {/* Site do Contato */}
        {ticket.contact.site && (
          <Tooltip title="Abrir Site" arrow>
            <IconButton
              className={classes.actionButtonIcons}
              onClick={() => {
                const site = ticket.contact.site.trim();
                const url = /^https?:\/\//i.test(site) ? site : `http://${site}`;
                window.open(url, '_blank');
              }}
            >
              <Globe />
            </IconButton>
          </Tooltip>
        )}

        {/* Gerenciar Atendentes */}
        <Tooltip title="Gerenciar Atendentes" arrow>
          <IconButton
            className={classes.actionButtonIcons}
            onClick={handleOpenAttendantsModal}
          >
            <UserPlus />
          </IconButton>
        </Tooltip>

        {/*Criar Tarefas */}
        {/* <Tooltip title={'Criar Tarefa'} arrow>
                  <IconButton
                    className={classes.actionButtonIcons}
                    onClick={handleOpenTaskModal}
                  >
                    <CheckSquare />
                  </IconButton>
                </Tooltip> */}

        {/* Transferir */}
        <Tooltip title="Transferir" arrow>
          <IconButton
            className={classes.actionButtonIcons}
            onClick={handleOpenTransferModal}
          >
            <Repeat />
          </IconButton>
        </Tooltip>
      </>
    )
  }

  return (
    <div className={classes.actionButtonsContainer}>
      <NewTicketModalWecloud
        modalOpen={newTicketModalOpen}
        onClose={handleNewTicketModalClose}
        initialContact={ticket.contact}
        isEditing={ticket.chatbot}
        isFromTicketActionButtons={true}
        ticketId={ticket.id}
        preselectedWhatsappId={ticket.whatsappId}
      />
      <TicketOptionsMenu
        ticket={ticket}
        anchorEl={anchorEl}
        menuOpen={ticketOptionsMenuOpen}
        handleClose={handleCloseTicketOptionsMenu}
        showTabGroups={showTabGroups}
      />
      <ConfirmationModal
        title={`${i18n.t('ticketOptionsMenu.confirmationModal.title')}${ticket.id
          } ${i18n.t('ticketOptionsMenu.confirmationModal.titleFrom')} ${ticket.contact.name
          }?`}
        open={confirmationOpen}
        onClose={setConfirmationOpen}
        onConfirm={handleDeleteTicket}
      >
        {i18n.t('ticketOptionsMenu.confirmationModal.message')}
      </ConfirmationModal>

      {shouldRequireClosingReason(ticket) && (
        <ClosingReasonModal
          open={closingReasonModalOpen}
          onClose={handleClosingReasonCancel}
          onConfirm={handleClosingReasonConfirm}
          ticket={ticket}
        />
      )}

      <TransferWhenClosingModal
        open={transferWhenClosingModalOpen}
        onClose={handleTransferWhenClosingClose}
        onConfirmTransfer={handleConfirmTransferWhenClosing}
        onConfirmClose={executeFinalCloseSteps}
        ticket={ticket}
        linkedAttendants={linkedAttendants}
      />

      <TransferTicketModalCustom
        modalOpen={transferTicketModalOpen}
        onClose={handleCloseTransferTicketModal}
        ticketid={ticket.id}
      />

      <TicketAttendantsModal
        open={attendantsModalOpen}
        onClose={handleCloseAttendantsModal}
        ticket={ticket}
      />

      <ScheduleModal
        open={scheduleModalOpen}
        onClose={handleCloseScheduleModal}
        aria-labelledby="form-dialog-title"
        contactId={contactId}
      />

      <TaskModal
        open={taskModalOpen}
        onClose={handleCloseTaskModal}
        initialContactId={ticket.contact.id}
      />

      {/**Desktop View */}
      <div className={classes.actionButtons}>
        {/* Bloco Desktop para Tickets Fechados */}
        {!isMobile &&
          ticket.status === 'closed' &&
          canShowManagementButtons && (
            <>
              {isNotGroup && (
                <Tooltip title={'Informações de Contato'} arrow>
                  <IconButton
                    className={classes.actionButtonIcons}
                    onClick={handleInfoClick}
                    aria-label="Informações de Contato"
                  >
                    <Info />
                  </IconButton>
                </Tooltip>
              )}
              <Tooltip title="Novo Atendimento" arrow>
                <IconButton
                  className={classes.actionButtonNewTicketIcon}
                  onClick={() => setNewTicketModalOpen(true)}
                  aria-label="Novo Atendimento"
                >
                  <CirclePlus />
                </IconButton>
              </Tooltip>
              <ButtonWithSpinner
                loading={loading}
                startIcon={<Replay />}
                size="small"
                onClick={e => handleUpdateTicketStatus(e, 'open', user?.id)}
              >
                {i18n.t('messagesList.header.buttons.reopen')}
              </ButtonWithSpinner>
            </>
          )}
        {!isMobile &&
          // (ticket.status === 'open' || (showTabGroups && ticket.isGroup)) && (
          //   <>
          //     {!ticket.isGroup && (
          //       <Tooltip title={'Histórico'} arrow>
          //         <IconButton
          //           className={classes.actionButtonIcons}
          //           onClick={handleInfoClick}
          //         >
          //           <Info />
          //         </IconButton>
          //       </Tooltip>
          //     )}

          //     {ticket.contact.site && (
          //       <Tooltip title="Abrir Site" arrow>
          //         <IconButton
          //           className={classes.actionButtonIcons}
          //           onClick={() => window.open(ticket.contact.site, '_blank')}
          //         >
          //           <Globe />
          //         </IconButton>
          //       </Tooltip>
          //     )}

          //     <Tooltip title={'Gerenciar Atendentes'} arrow>
          //       <IconButton
          //         className={classes.actionButtonIcons}
          //         onClick={handleOpenAttendantsModal}
          //       >
          //         <UserPlus />
          //       </IconButton>
          //     </Tooltip>

          //     <Tooltip title={'Transferir'} arrow>
          //       <IconButton
          //         className={classes.actionButtonIcons}
          //         onClick={handleOpenTransferModal}
          //       >
          //         <Repeat />
          //       </IconButton>
          //     </Tooltip>

          //     <Tooltip title={'Criar Tarefa'} arrow>
          //         <IconButton
          //           className={classes.actionButtonIcons}
          //           onClick={handleOpenTaskModal}
          //         >
          //           <CheckSquare />
          //         </IconButton>
          //       </Tooltip>

          //     {(!showTabGroups || !ticket.isGroup) && (
          //       <>
          //         <Tooltip
          //           title={i18n.t('messagesList.header.buttons.schedule')}
          //           arrow
          //         >
          //           <IconButton
          //             onClick={handleOpenScheduleModal}
          //             className={classes.actionButtonIcons}
          //           >
          //             <Calendar />
          //           </IconButton>
          //         </Tooltip>

          //         <Tooltip title="Finalizar" arrow>
          //           <IconButton
          //             onClick={handleOpenClosingReasonModal}
          //             className={classes.resolveButton}
          //           >
          //             <CircleCheck />
          //           </IconButton>
          //         </Tooltip>
          //       </>
          //     )}

          //     <TicketOptionsMenu
          //       ticket={ticket}
          //       anchorEl={anchorEl}
          //       menuOpen={ticketOptionsMenuOpen}
          //       handleClose={handleCloseTicketOptionsMenu}
          //       showTabGroups={showTabGroups}
          //     />
          //     <ConfirmationModal
          //       title={`${i18n.t('ticketOptionsMenu.confirmationModal.title')}${
          //         ticket.id
          //       } ${i18n.t('ticketOptionsMenu.confirmationModal.titleFrom')} ${
          //         ticket.contact.name
          //       }?`}
          //       open={confirmationOpen}
          //       onClose={setConfirmationOpen}
          //       onConfirm={handleDeleteTicket}
          //     >
          //       {i18n.t('ticketOptionsMenu.confirmationModal.message')}
          //     </ConfirmationModal>

          //     {shouldRequireClosingReason(ticket) && (
          //       <ClosingReasonModal
          //         open={closingReasonModalOpen}
          //         onClose={handleClosingReasonCancel}
          //         onConfirm={handleClosingReasonConfirm}
          //         ticket={ticket}
          //       />
          //     )}

          //     <TransferTicketModalCustom
          //       modalOpen={transferTicketModalOpen}
          //       onClose={handleCloseTransferTicketModal}
          //       ticketid={ticket.id}
          //     />

          //     <TicketAttendantsModal
          //       open={attendantsModalOpen}
          //       onClose={handleCloseAttendantsModal}
          //       ticket={ticket}
          //     />

          //     <ScheduleModal
          //       open={scheduleModalOpen}
          //       onClose={handleCloseScheduleModal}
          //       aria-labelledby="form-dialog-title"
          //       contactId={contactId}
          //     />

          //     <TaskModal
          //       open={taskModalOpen}
          //       onClose={handleCloseTaskModal}
          //       initialContactId={ticket.contact.id}
          //     />
          //   </>
          // )}
          isTicketOpenOrGroup && (
            <>
              {renderMainActions()}
              {canShowManagementButtons && (
                <>
                  <Tooltip
                    title={i18n.t('messagesList.header.buttons.schedule')}
                    arrow
                  >
                    <IconButton
                      onClick={handleOpenScheduleModal}
                      className={classes.actionButtonIcons}
                    >
                      <Calendar />
                    </IconButton>
                  </Tooltip>

                  <Tooltip title="Finalizar" arrow>
                    <IconButton
                      onClick={handleOpenClosingReasonModal}
                      className={classes.resolveButton}
                    >
                      <CircleCheck />
                    </IconButton>
                  </Tooltip>
                </>
              )}
            </>
          )}

        {!isMobile &&
          ticket.status === 'pending' &&
          canShowManagementButtons && (
            <div className={classes.pendingButtonsWrapper}>
              {isNotGroup && (
                <Tooltip title={'Informações de Contato'} arrow>
                  <IconButton
                    className={classes.actionButtonIcons}
                    onClick={handleInfoClick}
                    aria-label="Informações de Contato"
                  >
                    <Info />
                  </IconButton>
                </Tooltip>
              )}
              <ButtonPrimary
                loading={loading}
                onClick={handleOpenTransferModal}
                icon={UserRoundArrowLeft}
                label={i18n.t('messagesList.header.buttons.transfer')}
              />

              <ButtonAddNew
                loading={loading}
                label={i18n.t('messagesList.header.buttons.accept')}
                startIcon={<CircleCheck size={16} />}
                onClick={e => {
                  if (ticket.chatbot) {
                    setNewTicketModalOpen(true)
                  } else {
                    handleUpdateTicketStatus(e, 'open', user?.id)
                  }
                }}
              />
            </div>
          )}

        {!isMobile && (
          <Tooltip title="Fechar Conversa">
            <IconButton
              onClick={handleIconButtonClick}
              className={classes.actionButtonIcons}
            >
              <X />
            </IconButton>
          </Tooltip>
        )}
      </div>

      {/**Mobile View */}
      <div className={classes.actionButtons}>
        {isMobile && (
          <IconButton
            className={classes.actionButtonIcons}
            onClick={handleOpenMobileMenu}
          >
            <CirclePlus />
          </IconButton>
        )}
        <Menu
          anchorEl={mobileAnchorEl}
          open={mobileMenuOpen}
          onClose={handleCloseMobileMenu}
          getContentAnchorEl={null}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          className={classes.menu}
        >
          {/* Opção Histórico */}
          {isNotGroup && (
            <MenuItem
              key="mobile-info"
              onClick={() => {
                handleInfoClick()
                handleCloseMobileMenu()
              }}
            >
              <Info size={20} style={{ marginRight: 10 }} />
              Histórico
            </MenuItem>
          )}

          {/* Opção Gerenciar Atendentes */}
          {isTicketOpenOrGroup && [
            <MenuItem
              key="mobile-attendants"
              onClick={() => {
                handleOpenAttendantsModal()
                handleCloseMobileMenu()
              }}
            >
              <Users size={20} style={{ marginRight: 10 }} />
              Atendentes
            </MenuItem>,

            <MenuItem
              key="mobile-transfer"
              onClick={e => {
                handleCloseMobileMenu()
                setTimeout(() => {
                  handleOpenTransferModal(e)
                }, 100)
              }}
            >
              <Repeat size={20} style={{ marginRight: 10 }} />
              Transferir
            </MenuItem>,

            /* Opção Tarefa */
            /* <MenuItem
                onClick={() => {
                  handleOpenTaskModal()
                  handleCloseMobileMenu()
                }}
              >
                <CheckSquare size={20} style={{ marginRight: 10 }} />
                Criar Tarefa
              </MenuItem> */

            ...(canShowManagementButtons
              ? [
                /* Opção Agendamento */
                <MenuItem
                  key="mobile-schedule"
                  onClick={() => {
                    handleOpenScheduleModal()
                    handleCloseMobileMenu()
                  }}
                >
                  <Calendar size={20} style={{ marginRight: 10 }} />
                  Agendar
                </MenuItem>,

                /* Opção Finalizar - Com destaque em vermelho se desejar */
                <MenuItem
                  key="mobile-finish"
                  onClick={() => {
                    handleCloseMobileMenu()
                    handleOpenClosingReasonModal()
                  }}
                  style={{ color: theme.palette.green_200.main }}
                >
                  <CircleCheck size={20} style={{ marginRight: 10 }} />
                  Finalizar Atendimento
                </MenuItem>
              ]
              : [])
          ]}

          {ticket.status === 'closed' && canShowManagementButtons && (
            <MenuItem
              key="mobile-new-ticket"
              onClick={() => {
                handleCloseMobileMenu()
                setNewTicketModalOpen(true)
              }}
            >
              <CirclePlus size={20} style={{ marginRight: 10 }} /> Novo
              Atendimento
            </MenuItem>
          )}

          {/* CASO O TICKET ESTEJA PENDENTE */}
          {ticket.status === 'pending' &&
            canShowManagementButtons && [
              <MenuItem
                key="mobile-accept"
                onClick={e => {
                  handleCloseMobileMenu()
                  if (ticket.chatbot) {
                    setNewTicketModalOpen(true)
                  } else {
                    handleUpdateTicketStatus(e, 'open', user?.id)
                  }
                }}
              >
                <CircleCheck size={20} style={{ marginRight: 10 }} /> Aceitar
                Atendimento
              </MenuItem>,
              <MenuItem
                key="mobile-pending-transfer"
                onClick={e => {
                  handleCloseMobileMenu()
                  setTimeout(() => {
                    handleOpenTransferModal(e)
                  }, 100)
                }}
              >
                <Repeat size={20} style={{ marginRight: 10 }} /> Transferir
              </MenuItem>
            ]}
        </Menu>
      </div>
    </div>
  )
}

export default TicketActionButtonsCustom
